import { ChangeEvent, FC, ReactNode } from 'react';
import tag from 'blacklist-tag';
import styled from 'styled-components';
import { borderRadius, boxShadow, color, flex, height, space, width } from 'styled-system';
import { StyledSystemProps } from '../../../theme/StyledSystemProps';
import { ThemeInterface } from '../../../theme/ThemeInterface';

interface Props extends StyledSystemProps {
  bg?: string;
  name?: string;
  type?: string;
  color?: string;
  width?: string | number;
  height?: string | number;
  boxShadow?: string;
  placeholder?: string;
  showEyeIcon?: boolean;
  defaultChecked?: boolean;
  children?: ReactNode;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  borderRadius?: string | number;
  id?: string;
  readOnly?: boolean;
  value?: string | number | string[];
}

const CleanInput = tag('textarea', ['borderRadius']);

const StyledTextArea = styled(CleanInput)`
  ${flex};
  ${space};
  ${width};
  ${color};
  ${height};
  ${boxShadow};
  ${borderRadius};
  display: flex;
  position: relative;
  box-sizing: border-box;
  border: 1px solid rgba(50, 50, 93, 0.2);
  font-size: ${(props: ThemeInterface) => props.theme.fontSize[0]};
  &:disabled {
    opacity: 0.8;
  }
`;

const TextAreaWrap = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  width: 100%;
`;

const TextArea: FC<Props> = (props: Props) => {
  return (
    <TextAreaWrap>
      <StyledTextArea {...props} />
    </TextAreaWrap>
  );
};

export default TextArea;

TextArea.defaultProps = {
  width: '100%',
  height: '120px',
  bg: 'paleGrey',
  borderRadius: 4,
};
